import * as _ from "lodash";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {CurrencyBO} from "./CurrencyBO";


export class CurrencyBOValidations{

    static ValidateEmptyFields(aBO: CurrencyBO): Promise<void> {

        return new Promise((resolve,error)=>{

            // Source ID




            if (_.isEmpty(aBO.WB_Currency.cif.CURRENCY_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'Emptyname',
                        type: MessageType.Error,
                        title: "Currency Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('Emptyname')
            }

            if (_.isEmpty(aBO.WB_Currency.cif.CURRENCY_ID) || _.isNull(aBO.WB_Currency.cif.CURRENCY_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyId',
                        type: MessageType.Error,
                        title: "External Currency ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyId')
            }

            // ISO Currency- ISO_CURRENCY
            if(_.isEmpty(aBO.WB_Currency.cif.ISO_CURRENCY) || _.isUndefined(aBO.WB_Currency.cif.ISO_CURRENCY) || _.isNull(aBO.WB_Currency.cif.ISO_CURRENCY)){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'isocurrency',
                        type: MessageType.Error,
                        title: "ISO Currency cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('isocurrency')
            }

            if (_.isEmpty(aBO.WB_Currency.cif.CURRENCY_SYMBOL) || _.isNull(aBO.WB_Currency.cif.CURRENCY_SYMBOL)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'currencysymbol',
                        type: MessageType.Error,
                        title: "Currency Symbol cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('currencysymbol')
            }

            if(_.isUndefined(aBO.WB_Currency.cif.DECIMAL_DIGITS) || _.isNull(aBO.WB_Currency.cif.DECIMAL_DIGITS)){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'decimaldigits',
                        type: MessageType.Error,
                        title: "No. of Places after Decimal cannot be empty. Please enter a number between 0-2",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('decimaldigits')
            }



            if(aBO.WB_Currency.cif.DECIMAL_DIGITS < 0){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'decimaldigitsminval',
                        type: MessageType.Error,
                        title: "No. of Places after Decimal cannot be less than Zero",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('decimaldigitsminval')
            }

            if(aBO.WB_Currency.cif.DECIMAL_DIGITS > 2){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'decimaldigitsmaxval',
                        type: MessageType.Error,
                        title: "No. of Places after Decimal cannot be greater than 2",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('decimaldigitsmaxval')
            }
            //check for period, commas, hyphens
            const decimalDigitsChecks=aBO.WB_Currency.cif.DECIMAL_DIGITS.toString()
            if(decimalDigitsChecks.includes('.') || decimalDigitsChecks.includes(',') || decimalDigitsChecks.includes('-') || _.isEmpty(decimalDigitsChecks)){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'decimaldigitsformat',
                        type: MessageType.Error,
                        title: "For 'No. of Places after Decimal' please enter a whole number between 0-2",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('decimaldigitsformat')
            }


            if(_.isEmpty(aBO.WB_Currency.cif.DECIMAL_SYMBOL) || _.isUndefined(aBO.WB_Currency.cif.DECIMAL_SYMBOL) || _.isNull(aBO.WB_Currency.cif.DECIMAL_SYMBOL)){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'decimalsymbol',
                        type: MessageType.Error,
                        title: "Decimal Symbol cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('decimalsymbol')
            }


            if (_.isEmpty(aBO.WB_Currency.cif.GROUPING_SYMBOL) || _.isNull(aBO.WB_Currency.cif.GROUPING_SYMBOL)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'groupingsymbol',
                        type: MessageType.Error,
                        title: "Digit Grouping Symbol cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('groupingsymbol')
            }

            if (_.isEmpty(aBO.WB_Currency.cif.NEGATIVE_FORMAT) || _.isNull(aBO.WB_Currency.cif.NEGATIVE_FORMAT)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'negativeformat',
                        type: MessageType.Error,
                        title: "Negative Format cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('negativeformat')
            }

            if (_.isEmpty(aBO.WB_Currency.cif.CURRENCY_SYMBOL_POSITION) || _.isNull(aBO.WB_Currency.cif.CURRENCY_SYMBOL_POSITION)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'symbolposition',
                        type: MessageType.Error,
                        title: "Currency Symbol Position cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('symbolposition')
            }

            resolve()
        })
    }


}